import React from 'react';
import PT from 'prop-types';
import Slider from 'react-slick';
import { ImageStack } from '@procore/core-icons';
import { Box, H3, Typography, useI18nContext } from '@procore/core-react';
import {
  Slide,
  ArrowContainer,
  EmptySlide,
  SlideContainer,
} from '@/react/styles/v2';
import { VideoPreview } from '../Sections/VideoPreview';
import { ArrowPrev, ArrowNext } from '@/react/components';

const MainCarousel = ({
  screenshots,
  wistiaId,
  onBeforeChange,
  setMainCarousel,
  thumbnailCarousel,
  openImageModal,
}) => {
  const i18n = useI18nContext();
  const settings = {
    focusOnSelect: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    adaptiveHeight: true,
    beforeChange: onBeforeChange,
    prevArrow: (
      <ArrowContainer>
        <ArrowPrev />
      </ArrowContainer>
    ),
    nextArrow: (
      <ArrowContainer>
        <ArrowNext />
      </ArrowContainer>
    ),
  };

  return screenshots.length !== 0 ? (
    <Slider {...settings} asNavFor={thumbnailCarousel} ref={setMainCarousel}>
      {wistiaId && (
        <SlideContainer>
          <VideoPreview wistiaId={wistiaId} />
        </SlideContainer>
      )}
      {screenshots?.map((slide, index) => (
        <SlideContainer key={slide.url}>
          <Slide
            src={slide.url}
            onClick={openImageModal}
            data-testid={`media-section-slide-${index}`}
          />
        </SlideContainer>
      ))}
    </Slider>
  ) : (
    <EmptySlide data-testid="no-media-display">
      <Box
        display="flex-column"
        alignItems="center"
        justifyContent="center"
        gap="md"
        className="dialog"
      >
        <ImageStack />
        <H3>{i18n.t('appDetails.media.titleNoMedia')}</H3>
        <Typography intent="body" className="font-size-body">
          {i18n.t('appDetails.media.descriptionNoMedia')}
        </Typography>
      </Box>
    </EmptySlide>
  );
};

MainCarousel.propTypes = {
  screenshots: PT.arrayOf(
    PT.shape({
      url: PT.string.isRequired,
    })
  ),
  wistiaId: PT.string,
  onBeforeChange: PT.func.isRequired,
  setMainCarousel: PT.func.isRequired,
  thumbnailCarousel: PT.shape({}),
  openImageModal: PT.func.isRequired,
};

export default MainCarousel;
